module.exports = __webpack_public_path__ + "img/cloud.fb157f04.svg";